export default __webpack_public_path__ + "static/media/offer_right.58dba89b.svg";